const appRoutes = {
    start: '/',
    menu: '/menu',
    checkout: '/checkout',
    address: '/delivery-address',
    phone: '/confirm-phone',
    table: '/table-select',
    orderStatus: '/order-status',
    menuCategory: (categoryId: string)=> `/menu#${categoryId}`,
};

export default appRoutes;